export const BreadcrumbPlaceholder = () => (
  <div className="h-breadcrumb z-[-1]">&#8203;</div>
);
